import React from 'react';
import PropTypes from 'prop-types';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import Box from '@material-ui/core/Box';
import { isMobileMedia } from 'bento-ordering/utils/media';

class MobileFooter extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.node,
      PropTypes.func,
      PropTypes.array
    ])
  };
  render() {
    if (!isMobileMedia()) {
      return null;
    }

    return (
      <Box mt={4}>
        <BottomNavigation>{this.props.children}</BottomNavigation>
      </Box>
    );
  }
}

export default MobileFooter;
